export const PERMISSIONS = {
  PARAMETERS: {
    POSITIONS_FLEETS: {
      view: 'AccessMasterTablesScreen',
      edit: 'EditMasterTables',
    },
    FLEET_ASSIGNMENT: {
      view: 'AccessMasterTablesScreen',
      edit: 'EditMasterTables',
    },
    MANAGE_PARAMETERS: {
      view: 'AccessParametersScreen',
      edit: 'EditParameters',
    },
    RELEASE_NOTES: {
      view: 'AccessMasterTablesScreen',
      edit: 'EditMasterTables',
    },
    RELEASE_NOTES_BYOD: {
      view: 'AccessMasterTablesScreen',
      edit: 'EditMasterTables',
    },
    ISSUES: {
      view: 'AccessIncidentsScreen',
      edit: 'ChangeIncidents',
    },
  },
  MESSAGES: {
    MAILBOX: {
      view: 'AccessMessagesScreen',
      edit: 'CreateMessages',
    },
    SUBJECTS: {
      view: 'AccessMasterTablesScreen',
      edit: 'EditMasterTables',
    },
    ADDRESSES: {
      view: 'AccessMasterTablesScreen',
      edit: 'EditMasterTables',
    },
    NEW_MESSAGE: {
      view: 'CreateMessages',
      edit: 'CreateMessages',
    },
  },
  ROLES_MANAGEMENT: {
    view: 'AccessRolesScreen',
    edit: 'EditRoles',
  },
  USERS_MANAGEMENT: {
    view: 'AccessUsersScreen',
    edit: 'EditUsers',
  },
  REPORTS: {
    view: 'AccessReportsScreen',
    edit: 'EditReportsScreen',
  },
  EVALUATIONS: {
    view: 'AccessEvaluationsScreen',
    edit: 'EditEvaluationsScreen',
  },
  APP_STATUS: {
    view: 'AccessOtherIncidentsScreen',
    edit: 'EditOtherIncidents',
  },
  MANAGEMENT_INCIDENT: {
    view: 'AccessOtherIncidentsScreen',
    edit: 'EditOtherIncidents',
  },
};
